import createUmbracoMediaItemProps from '@/components/atoms/media/umbracoMediaElementPropsFactory'
import { CallToAction } from './callToAction'
import { GetUmbracoBaseUrl } from '@/utils/urlHelpers'
import { MediaImageData } from '@/components/atoms/media/MediaImage'

export default function callToActionFactory(data: any, key: string | number) {
  const content = data.content.properties

  const mediaItem = {
    contentType: 'imageComponent',
    properties: {
      image: content?.image,
    },
  }
  const mediaItemProps = createUmbracoMediaItemProps({
    mediaItemContent: mediaItem,
    umbracoBaseUrl: GetUmbracoBaseUrl(),
  })

  return (
    <CallToAction
      key={key}
      title={content.title.markup}
      mediaData={mediaItemProps as MediaImageData}
      primaryButtonText={content?.button?.[0]?.title}
      primaryButtonUrl={content?.button?.[0]?.url}
    />
  )
}
